module.exports = {"heading":"專業團隊","member":[{"image":"vgm","sign":"...","name":"總經理 鍾明峰","title":"自薦標題自薦標題","text":"自我介紹與工作職掌還有聯絡方式。自我介紹與工作職掌還有聯絡方式。自我介紹與工作職掌還有聯絡方式。自我介紹與工作職掌還有聯絡方式。自我介紹與工作職掌還有聯絡方式。"},{"image":"manager","sign":"...","name":"經理 陳啟祥","title":"自薦標題自薦標題","text":"畢業於中華科技大學企業管理系，89年2月開始從事漏水檢測與管線調查，93年9月創立敏泰資訊股份有限公司，建立「安全、確實、迅速」為宗旨，累積公民營漏水檢測案件超過150案，管線調查案件超過50案。"}]}


//////////////////
// WEBPACK FOOTER
// ./src/pages/TeamPage/locale/zh.json
// module id = 587
// module chunks = 0